<template>
  <v-overlay v-if="isLoading" z-index="10">
    <v-progress-circular indeterminate size="64" />
  </v-overlay>
  <div v-else>
    <v-list-item>
      <div class="list-item">
        <v-icon
          class="mr-2"
          :color="contract.status === 'completed' ? 'success' : 'grey'"
        >
          {{ getIcon(contract) }}
        </v-icon>
        <v-list-item-content @click="$emit('onSelect')">
          <div class="item-right">
            <div>
              <div class="d-flex" :class="{ 'flex-column': isMobile }">
                {{ contract.displayName }}
              </div>
              <span class="status">{{ contract.status | startCase }}</span>
            </div>
          </div>
        </v-list-item-content>
      </div>
    </v-list-item>
  </div>
</template>

<script>
import { getIconByStatus } from "@/utils/offers";

export default {
  data() {
    return {
      fileDialog: { dialog: false }
    };
  },
  props: {
    contract: {
      type: Object,
      required: true
    },
    isLoading: Boolean
  },
  methods: {
    getIcon(contract) {
      return getIconByStatus(contract.status);
    }
  }
};
</script>

<style lang="scss"></style>
